import React from "react";
import { useNavigate } from "react-router-dom";
import { Brand, PoweredBy } from "@/components/Brand";
import { QrCode, LayoutDashboard, MessageCircle, ArrowRight } from "lucide-react";

const cards = [
  { key: "scan", to: "/scan", icon: QrCode, title: "Scan & Earn", desc: "Painter reward journey — scan a coupon, pick your reward, get paid.", tag: "Public · Mobile-first", testid: "landing-scan" },
  { key: "admin", to: "/admin", icon: LayoutDashboard, title: "Admin Portal", desc: "Dashboards, coupons, wallets, UPI, gifts, campaigns, imports & audit.", tag: "RBAC · Desktop", testid: "landing-admin" },
  { key: "sim", to: "/admin/simulator", icon: MessageCircle, title: "WhatsApp Simulator", desc: "Replay every WhatsApp conversation flow before live credentials.", tag: "Internal tool", testid: "landing-simulator" },
];

export default function Landing() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="border-b border-gray-100 px-6 py-4 flex items-center justify-between">
        <Brand />
        <button onClick={() => nav("/login")} data-testid="landing-login-btn"
          className="text-sm font-semibold text-[#8B0000] hover:underline">Admin Login →</button>
      </header>
      <main className="flex-1 max-w-6xl mx-auto w-full px-6 py-12 md:py-20">
        <span className="inline-block text-xs font-semibold tracking-wider uppercase text-[#8B0000] bg-[#FDF2F2] px-3 py-1 rounded-full">Influencer · Dealer · Consumer Loyalty</span>
        <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900 max-w-3xl leading-[1.05]">
          One platform for every <span className="text-[#8B0000]">reward journey.</span>
        </h1>
        <p className="mt-5 text-lg text-gray-600 max-w-2xl">QR → earn → redeem, with hardened fraud controls, append-only wallets, UPI & gift redemption, and explainable AI campaigns.</p>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((c) => (
            <button key={c.key} data-testid={c.testid} onClick={() => nav(c.to)}
              className="group text-left bg-white border border-gray-200 rounded-2xl p-7 hover:border-[#8B0000] hover:shadow-lg transition-all duration-200">
              <div className="h-12 w-12 rounded-xl bg-[#FDF2F2] flex items-center justify-center text-[#8B0000] group-hover:bg-[#8B0000] group-hover:text-white transition-colors">
                <c.icon className="h-6 w-6" />
              </div>
              <div className="mt-5 text-[11px] font-semibold uppercase tracking-wider text-gray-400">{c.tag}</div>
              <h3 className="mt-1 font-display text-xl font-bold text-gray-900">{c.title}</h3>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">{c.desc}</p>
              <div className="mt-4 flex items-center gap-1 text-sm font-semibold text-[#8B0000]">Open <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></div>
            </button>
          ))}
        </div>
      </main>
      <footer className="border-t border-gray-100 px-6 py-5 flex items-center justify-between">
        <span className="text-sm text-gray-500">© 2026 Jewell Paints</span>
        <PoweredBy />
      </footer>
    </div>
  );
}
